export var InlineToolbarButtons;
(function(InlineToolbarButtons) {
    InlineToolbarButtons["BOLD"] = 'Bold';
    InlineToolbarButtons["ITALIC"] = 'Italic';
    InlineToolbarButtons["UNDERLINE"] = 'Underline';
    InlineToolbarButtons["SEPARATOR"] = '|';
    InlineToolbarButtons["TITLE"] = 'Title';
    InlineToolbarButtons["ORDERED_LIST"] = 'OrderedList';
    InlineToolbarButtons["UNORDERED_LIST"] = 'UnorderedList';
    InlineToolbarButtons["BLOCKQUOTE"] = 'Blockquote';
    InlineToolbarButtons["ALIGNMENT"] = 'Alignment';
    InlineToolbarButtons[// These ones below are added via plugins, they therefore have different
    // names, if they go missing check the textButtons value inside the editor setup.
    "LINK"] = "LINK";
    InlineToolbarButtons["TEXT_COLOR"] = "TEXT_COLOR";
    InlineToolbarButtons["TEXT_HIGHLIGHT"] = "TEXT_HIGHLIGHT";
    InlineToolbarButtons["INDENT_INCREASE"] = 'INCREASE_INDENT';
    InlineToolbarButtons["INDENT_DECREASE"] = 'DECREASE_INDENT';
})(InlineToolbarButtons || (InlineToolbarButtons = {}));
